import { DatePipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface SubscriptionData {
  subscription_type: string;
  month_name: string;
  total_amount: number;
  all_total: number;
}

@Component({
  selector: 'app-acc-subscription-monthwise-report',
  templateUrl: './acc-subscription-monthwise-report.component.html',
  styleUrl: './acc-subscription-monthwise-report.component.scss'
})
export class AccSubscriptionMonthwiseReportComponent {

  months: string[] = [];
  subscriptionTypes: string[] = []; // dynamic now
  groupedTypes: string[][] = [];
  data: SubscriptionData[] = [];
  today: any;
  startDate: any;
  endDate: any;

  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AccSubscriptionMonthwiseReportComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data1: any
  ) {
    this.today = formatDate(new Date(), 'yyyy/MM/dd', 'en-IN', 'GMT+0530');
  }

  loading: boolean = false;

  private sortTypes(types: string[]): string[] {
    const fixedOrder = ['वार्षिक', 'पंचवार्षिक', 'त्रैवार्षिक'];
    const ordered: string[] = [];

    // add fixed ones in defined order if they exist
    fixedOrder.forEach(type => {
      if (types.includes(type)) {
        ordered.push(type);
      }
    });

    // add remaining ones (not in fixedOrder)
    const remaining = types.filter(t => !fixedOrder.includes(t));
    ordered.push(...remaining);

    return ordered;
  }

  ngOnInit(): void {
    this.startDate = this.data1['startDate'];
    this.endDate = this.data1['endDate'];

    const body = {
      startDate: this.data1['startDate'],
      endDate: this.data1['endDate']
    };

    this.loading = true;

    this.http.post<SubscriptionData[]>(
      'https://vivekweb.in/VivekApplication/get_monthwise_subscription_data_for_account_new.php',
      body
    ).subscribe({
      next: (res) => {
        this.data = res;
        this.months = [...new Set(res.map(d => d.month_name))];
        const rawTypes = [...new Set(res.map(d => d.subscription_type))];
        this.subscriptionTypes = this.sortTypes(rawTypes);   // 👈 sorted types
        this.groupedTypes = this.chunkArray(this.subscriptionTypes, 3);
      },
      error: (err) => console.error(err),
      complete: () => this.loading = false
    });
  }


  getAmount(month: string, type: string): number {
    const entry = this.data.find(d => d.month_name === month && d.subscription_type === type);
    return entry ? entry.total_amount : 0;
  }

  getTotalAllAmt(): number {
    return this.months.reduce((sum, month) => sum + this.getAllAmt(month), 0);
  }

  getTotalAmount(type: string): number {
    return this.months.reduce((sum, month) => sum + this.getAmount(month, type), 0);
  }

  getTotalNextCarryAmount(type: string): number {
    return this.months.reduce((sum, month) => sum + this.getNextCarryAmount(month, type), 0);
  }

  getNextCarryAmount(month: string, type: string): number {
    const monthMultipliersForAnnual: { [key: string]: number } = {
      'April': 0,
      'May': 1,
      'June': 2,
      'July': 3,
      'August': 4,
      'September': 5,
      'October': 6,
      'November': 7,
      'December': 8,
      'January': 9,
      'February': 10,
      'March': 11
    };

    const monthMultipliersForTriAnnual: { [key: string]: number } = {
      'April': 24,
      'May': 25,
      'June': 26,
      'July': 27,
      'August': 28,
      'September': 29,
      'October': 30,
      'November': 31,
      'December': 32,
      'January': 33,
      'February': 34,
      'March': 35
    };

    const monthMultipliersForFifthAnnual: { [key: string]: number } = {
      'April': 48,
      'May': 49,
      'June': 50,
      'July': 51,
      'August': 52,
      'September': 53,
      'October': 54,
      'November': 55,
      'December': 56,
      'January': 57,
      'February': 58,
      'March': 59
    };

    const monthOnly = month.split(' ')[0];

    const entry = this.data.find(d => d.month_name === month && d.subscription_type === type);
    if (!entry) return 0;

    if (type === 'वार्षिक') {
      const multiplier = monthMultipliersForAnnual[monthOnly] ?? 0;
      const carryAmount = (entry.total_amount / 12) * multiplier;
      return Number(carryAmount.toFixed(2));
    } else if (type === 'त्रैवार्षिक') {
      const multiplier = monthMultipliersForTriAnnual[monthOnly] ?? 0;
      const carryAmount = (entry.total_amount / 36) * multiplier;
      return Number(carryAmount.toFixed(2));
    } else if (type === 'पंचवार्षिक') {
      const multiplier = monthMultipliersForFifthAnnual[monthOnly] ?? 0;
      const carryAmount = (entry.total_amount / 60) * multiplier;
      return Number(carryAmount.toFixed(2));
    } else {
      const multiplier = monthMultipliersForAnnual[monthOnly] ?? 0;
      const carryAmount = (entry.total_amount / 12) * multiplier;
      return Number(carryAmount.toFixed(2));
    }

    return 0;
  }

  getAllAmt(month: string): number {
    const entry = this.data.find(d => d.month_name === month);
    return entry ? entry.all_total : 0;
  }

  closeexp(): void {
    this.dialogRef.close();
    this.data = [];
  }

  chunkArray(arr: any[], size: number): any[][] {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

}